import Cookies from 'js-cookie'

const TokenKey = 'X-Auth-Token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  Cookies.set(TokenKey, token)
}

export function getUserName () {
  return Cookies.get('username')
}

export function setUserName (username) {
  Cookies.set('username', username)
}

export function getCustId () {
  return Cookies.get('custid')
}

export function setCustId (custid) {
  Cookies.set('custid', custid)
}

export function getMobiletelno () {
  return Cookies.get('mobiletelno')
}

export function setMobiletelno (mobiletelno) {
  Cookies.set('mobiletelno', mobiletelno)
}

export function getUserType () {
  return Cookies.get('userType')
}

export function setUserType (userType) {
  Cookies.set('userType', userType)
}

export function clearUserInfo () {
  Cookies.remove(TokenKey)
  Cookies.remove('username')
  Cookies.remove('custid')
  Cookies.remove('mobiletelno')
  Cookies.remove('userType')
}

const auth = {
  getToken,
  setToken,
  getUserName,
  setUserName,
  getCustId,
  setCustId,
  getMobiletelno,
  setMobiletelno,
  getUserType,
  setUserType,
  clearUserInfo
}

export default auth



// WEBPACK FOOTER //
// ./src/utils/auth.js